import {BeforeSpinStopPresentationController} from "@nolimitcity/slot-game/bin/core/beforespinstoppresentation/BeforeSpinStopPresentationController";
import {ThorParsedGameData} from "../../server/data/ThorParsedGameData";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {TimelineLite} from "gsap";
import {ThorGameMode} from "../../gamemode/ThorGameMode";
import {ThorScatterNearWinView} from "./ThorScatterNearWinView";
import {ThorGameModuleConfig} from "../../ThorGameModuleConfig";

/**
 * Created by Jerker Nord on 2019-07-02.
 */

export class ThorScatterNearWinController extends BeforeSpinStopPresentationController {

    private _reelsToNudge:boolean[];
    private _playScatterNearWin:boolean;
    private _scatterNearWinView:ThorScatterNearWinView;

    constructor(index:number) {
        super(index, "ThorScatterNearWinController");
        this._reelsToNudge = [false, false, false, false, false];
        this._scatterNearWinView = ThorGameModuleConfig.thorScatterNearWinView = new ThorScatterNearWinView();
    }

    protected parseFeatureTriggered(data:ThorParsedGameData):boolean {
        this._playScatterNearWin = data.mode == ThorGameMode.SCATTER_RESPIN;
        if(this._playScatterNearWin) {
            for(let i:number = 0; i < data.scatterPositionsBefore.length; i++) {
                if(data.scatterPositionsBefore[i] > -1 && data.scatterPositionsBefore[i] < 2) {
                    this._reelsToNudge[i] = true;
                } else {
                    this._reelsToNudge[i] = false;
                }
            }
        }
        return this._playScatterNearWin;
    }

    protected getSpinStopDelay(data:ThorParsedGameData):number {
        return GameSetting.isFastSpin ? 1 : 1.5;
    }

    protected startPresentation(timeline:TimelineLite):void {
        // Add near win animation on one or more reels
        for(let i:number = 0; i < this._reelsToNudge.length; i++) {
            if(this._reelsToNudge[i] == false) {
                this._scatterNearWinView.enableScatterAnimation(i);
            }
        }
    }

    protected stopPresentation(isAborted:boolean):void {
        if(isAborted == true) {
            //Do nothing?
        }
    }

    protected resetFeature() {
        //TODO: Do reset?
    }
}